import * as types from './types';

export const refreshTags = () => ({
  type: types.CHANGE_TAGS_VERSION
});
